export default __webpack_public_path__ + "img/GF.4a5a67f2a9c462cf319fba3ce99da97b.jpg";